module.exports = __webpack_public_path__ + "static/mum-profile-crop-264ea6fab3176c62504c7e572e9b85b3.jpg";